import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { useIsMobile } from "@/hooks/useMobile";
import { useEffect, useState } from "react";
import { capturePosthog } from "@/lib/posthog";

const StickyMobileCTA = () => {
  const isMobile = useIsMobile();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past hero (~500px)
      setVisible(window.scrollY > 500);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  if (!isMobile || !visible) return null;

  // Glisse depuis le bas à son apparition ; fond opaque : un flou derrière 95 % d'opacité ne se voit pas mais se recalcule à chaque image du défilement.
  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-3 bg-background border-t shadow-[0_-8px_24px_-12px_hsl(var(--foreground)/0.12)] safe-area-bottom motion-safe:animate-in motion-safe:slide-in-from-bottom-4 motion-safe:fade-in duration-base">
      <Button size="lg" className="w-full h-12 text-payfit-body !text-primary-foreground [&_*]:!text-primary-foreground" asChild>
        <Link
          to="/auth?mode=signup"
          onClick={() => {
            capturePosthog("landing_cta_try_free_clicked", {
              cta_id: "sticky_mobile_try_free",
              cta_label: "Essai gratuit 14 jours",
              cta_section: "sticky_mobile",
            });
            capturePosthog("landing_cta_clicked", {
              cta_id: "sticky_mobile_try_free",
              cta_label: "Essai gratuit 14 jours",
              cta_section: "sticky_mobile",
            });
          }}
        >
          Essai gratuit 14 jours
          <ArrowRight className="w-5 h-5 ml-2" />
        </Link>
      </Button>
    </div>
  );
};

export default StickyMobileCTA;
